const AUTH_TOKEN = 'authToken'

export function setAuthToken(token) {
  localStorage.setItem(AUTH_TOKEN, token)
}

export function resetAuthToken() {
  localStorage.removeItem(AUTH_TOKEN)
}

export function getAuthToken() {
  if (
    localStorage.getItem(AUTH_TOKEN) === 'null' ||
    !localStorage.getItem(AUTH_TOKEN)
  )
    return null
  return localStorage.getItem(AUTH_TOKEN)
}

export async function generateApiKey(length = 44) {
  return new Promise(res => {
    const characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ123456789012345678901234567890".split("");
    Array(2).fill().map(_ => characters.push('-', '_'))

    let i = 0
    let token = [];
    while (i < length) {
      const index = Math.floor(Math.random() * characters.length)
      token.push(characters[index ? index : '_']);
      i++
    }

    const apiKey = token.join('')
    setTimeout(() => {
      res(apiKey)
    }, 800)
  })
}

export default {
  setAuthToken,
  resetAuthToken,
  getAuthToken
}



// WEBPACK FOOTER //
// ./src/utils/auth.js